import { hasSubdivisionOrZipCodeShippingError, hasSubdivisionOrZipCodeTaxError } from './calculationError.utils';
import { getShippingMethods } from './getShippingMethods';
import { hasShippableItems } from './hasShippableItems';
export async function shouldNavigateToFastFlowCheckout(_ref) {
  var _checkoutSettings$ter, _checkoutSettings$che, _checkout$payNowTotal, _getShippingMethods;
  let {
    checkout,
    prevTotalAmount,
    shouldUpdateShippingAddress,
    checkoutSettings,
    useEstimationFlow
  } = _ref;
  const hasTermsAndConditions = (_checkoutSettings$ter = checkoutSettings.termsAndConditions) == null ? void 0 : _checkoutSettings$ter.enabled;
  const hasCustomField = ((_checkoutSettings$che = checkoutSettings.checkoutCustomField) == null ? void 0 : _checkoutSettings$che.show) && checkoutSettings.checkoutCustomField.mandatory;
  const hasShippingError = hasSubdivisionOrZipCodeShippingError(checkout);
  const hasTaxError = hasSubdivisionOrZipCodeTaxError(checkout);
  const hasTotalAmountMismatchWithLatestSeen = useEstimationFlow && prevTotalAmount !== ((_checkout$payNowTotal = checkout.payNowTotalAfterGiftCard) == null ? void 0 : _checkout$payNowTotal.amount);
  const shouldChooseShippingMethod = shouldUpdateShippingAddress && hasShippableItems(checkout) && ((_getShippingMethods = getShippingMethods(checkout, {})) == null ? void 0 : _getShippingMethods.length) !== 1;
  return shouldChooseShippingMethod || hasTermsAndConditions || hasCustomField || hasShippingError || hasTaxError || hasTotalAmountMismatchWithLatestSeen;
}
//# sourceMappingURL=shouldNavigateToFastFlow.js.map